// ==================== WAXUM MOCK DATA ====================
// All data below is mocked for the frontend-only version.

export const CODE = "WAXUM";

// -------- Duelbits (the only partner) --------
export const duelbits = {
  id: "duelbits",
  site: "duelbits.com",
  name: "Duelbits",
  logo: "/duelbits-logo.png",
  mainBonus: "Instant Rakeback + VIP Rewards", // MOCKED bonus text
  extra: "Wager Leaderboard under code WAXUM",
  url: "https://duelbits.com/?a=waxum",
  steps: [
    "Register on duelbits.com",
    `Go to Rewards and redeem code \"${CODE}\"`,
    "Enjoy instant rakeback, VIP perks & leaderboard entry",
  ],
};

// -------- Kick channel --------
// Live status is fetched in real time from the backend (/api/kick/status).
export const kickChannel = {
  slug: "waxumfriendly",
  url: "https://kick.com/waxumfriendly",
  embed: "https://player.kick.com/waxumfriendly",
};

export const socials = [
  {
    id: "twitter",
    name: "X / Twitter",
    handle: "@waxumfriendly",
    sub: "Stay in touch",
    action: "Follow",
    url: "https://x.com/waxumfriendly",
  },
  {
    id: "kick",
    name: "Kick",
    handle: "waxumfriendly",
    sub: "Watch the streams",
    action: "Watch",
    url: "https://kick.com/waxumfriendly",
  },
  {
    id: "discord",
    name: "Discord",
    handle: "WAXUM Community",
    sub: "Join the community",
    action: "Join",
    url: "https://discord.gg/wp9TfC8YPG",
  },
];

// -------- Duelbits leaderboard --------
// Real standings now come from the backend: GET /api/leaderboard
// (Duelbits affiliate API, cached server-side, updates every 5 minutes)

export const formatMoney = (n) =>
  "$" + n.toLocaleString("en-US", { maximumFractionDigits: 0 });
